const bootstrapScripts = [
  '/static/runtime-profiles.js',
  '/static/device-profile-selector.js'
]

const experienceScripts = [
  '/static/optimized-assets.js',
  '/static/lightweight-assets.js',
  '/static/fullscreen-assets.js',
  '/static/fullscreen-variant-selector.js',
  '/static/lightweight-media.js',
  '/static/motion-budget.js',
  '/static/adaptive-performance.js',
  '/static/reference-background.js',
  '/static/birth-hierarchy.js',
  '/static/birth-hierarchy-extra.js',
  '/static/universe-render-utils.js',
  '/static/galaxy-orbit.js',
  '/static/image-shape-detector.js',
  '/static/child-field-layout.js',
  '/static/batch-image-lifecycle.js',
  '/static/persistent-media-preloader.js',
  '/static/exact-effects.js',
  '/static/site.js'
]

export function configureUniverseBody () {
  document.body.dataset.backgroundMode = 'reference-full'
  document.body.dataset.cosmicTheme = 'storm'
  document.body.dataset.cosmicParticles = 'off'
  document.body.dataset.meteorScale = '1'
  document.body.dataset.birthChildMode = 'flat'
}

function loadScript (src) {
  const existing = document.querySelector(`script[data-universe-script="${src}"]`)
  if (existing) return Promise.resolve()

  return new Promise((resolve, reject) => {
    const script = document.createElement('script')
    script.src = src
    script.dataset.universeScript = src
    script.onload = resolve
    script.onerror = () => reject(new Error(`Unable to load ${src}`))
    document.body.appendChild(script)
  })
}

export function loadUniverseExperience () {
  return loadScripts(bootstrapScripts).then(() => {
    if (!window.UniverseDeviceProfileSelector || typeof window.UniverseDeviceProfileSelector.select !== 'function') {
      throw new Error('Device profile selector is unavailable')
    }
    return window.UniverseDeviceProfileSelector.select()
  }).then(() => loadScripts(experienceScripts)).then(() => {
    destroyUniverseExperience()
    if (typeof window.startUniverseSite !== 'function') {
      throw new Error('Universe site initializer is unavailable')
    }
    window.stopUniverseExperience = window.startUniverseSite()
  })
}

function loadScripts (sources) {
  return sources.reduce(
    (chain, src) => chain.then(() => loadScript(src)),
    Promise.resolve()
  )
}

export function destroyUniverseExperience () {
  const stop = window.stopUniverseExperience
  window.stopUniverseExperience = undefined
  if (typeof stop === 'function') stop()
}



// WEBPACK FOOTER //
// ./src/lib/universeExperience.js